import { render } from "./PortfolioFilterItem.vue?vue&type=template&id=245c40ee"
import script from "./PortfolioFilterItem.vue?vue&type=script&lang=js"
export * from "./PortfolioFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__